export enum ExtendedSearchType
{
    UID = 'UID',
    OWNER_NAME = 'OWNER_NAME',
    DOMAIN_ALIAS = 'DOMAIN_ALIAS'
}
